
    import { defineComponent, PropType } from "vue"

    export interface InputSwitchOption {
        label: string
        value: any
    }

    export default defineComponent({
        props: {
            disabled: {
                type: Boolean,
            },
            value: [String, Array],
            options: Array as PropType<InputSwitchOption[] & string[]>,
            multiselect: Boolean
        },
        components: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            isActive(option: InputSwitchOption) {
                return (this.multiselect ? this.value?.includes(option.value || option) : ((option.value || option) === this.value))
            },

            emit(option: InputSwitchOption) {
                if (!this.disabled) {
                    const values = (Array.isArray(this.value) ? this.value : [])
                    const optionValue = option.value || option
                    const res = this.multiselect ? (this.value?.includes(optionValue) ? values.filter((valueOne) => valueOne !== optionValue) : [...values, optionValue]) : option.value !== undefined ? option.value : option
                    this.$emit("update:value", res)
                }
            },

        },
    })

